module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-wave",
    on: {
      "click": function($event) {
        return _vm.$emit('click', _vm.wave.WaveGuid)
      }
    }
  }, [_c('div', {
    staticClass: "status-wave-meta-data"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.wave.WaveName))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.globals.toLocaleDateString(_vm.wave.WaveSince)) + " - " + _vm._s(_vm.globals.toLocaleDateString(_vm.wave.WaveUntil)))])]), _vm._v(" "), _c('div', {
    staticClass: "kpis"
  }, [(_vm.wave.SurveyInstances && _vm.wave.SurveyInstances.Status) ? [_c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.Count,
      "label": 'Count',
      "centerText": _vm.wave.SurveyInstances.Status.Count,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.Approval,
      "label": 'Approval',
      "centerText": _vm.wave.SurveyInstances.Status.Approval,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.InProgress,
      "label": 'InProgress',
      "centerText": _vm.wave.SurveyInstances.Status.InProgress,
      "showRing": false,
      "showSquare": true
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.SurveyInstances.Status.Reporting,
      "label": 'Reporting',
      "centerText": _vm.wave.SurveyInstances.Status.Reporting,
      "showRing": false,
      "showSquare": true
    }
  })] : _vm._e(), _vm._v(" "), (_vm.wave.Wave) ? [_c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Wave.InTime,
      "label": 'InTime',
      "centerText": _vm.wave.Wave.InTime,
      "isPercentage": true,
      "suffix": "%"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "kpis"
  }, [(_vm.wave.Approvals) ? [_c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Approvals.None,
      "label": 'None',
      "centerText": _vm.wave.Approvals.None,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Approvals.Open,
      "label": 'Open',
      "centerText": _vm.wave.Approvals.Open,
      "isPercentage": true,
      "suffix": "%"
    }
  }), _vm._v(" "), _c('StatIndicator', {
    attrs: {
      "value": _vm.wave.Approvals.Approved,
      "label": 'Approved',
      "centerText": _vm.wave.Approvals.Approved,
      "isPercentage": true,
      "suffix": "%"
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d768d3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatusManagement/StatusWave.vue
// module id = 1685
// module chunks = 1